import { useEffect } from "react";
import { useLocation } from "react-router";
import { useAnalytics } from "./PostHogProvider";
import { routePattern } from "./routePattern";

/** Manual `$pageview` on every route change, reporting the route pattern. */
export function usePageviews() {
  const { pathname } = useLocation();
  const { track, enabled } = useAnalytics();

  useEffect(() => {
    if (!enabled) return;
    // $current_url is query/hash-scrubbed in before_send
    track("$pageview", {
      $current_url: window.location.href,
      route: routePattern(pathname),
    });
  }, [pathname, enabled, track]);
}
